import jwtDecode from "jwt-decode";

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_USER,
  SESSION_USER_REFRESHED,
  SESSION_USER_REFRESH_FAILED,
} from 'actions';

import {isTokenValid} from 'utils';

import {userRoles} from '../../constants'

const noAuthState = {
  isAuthenticated: false,
  isAuthenticating: false,
  // Nothing to reconcile without a session.
  isSessionChecked: true,
  user: {
    username: 'Not authorized',
    avatar: '/images/avatars/avatar_11.png',
    roles: [userRoles.GUEST]
  }
};

const initState = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return noAuthState;
  }

  try {
    const decodedToken = jwtDecode(token);

    return {
      isAuthenticated: isTokenValid(decodedToken),
      isAuthenticating: false,
      // A token from localStorage carries LOGIN-TIME roles; AuthGuard waits
      // until /api/me has confirmed them (SessionRefresh). See
      // refreshSessionAction.js.
      isSessionChecked: !isTokenValid(decodedToken),
      user: {
        avatar: '/images/avatars/male.png',
        ...decodedToken,
      }
    }
  } catch (e) {

  }

  return noAuthState;
};

const initialState = initState();

export const authReducer = (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case LOGIN_SUCCESS: {
      const {token} = payload;
      const decodedToken = jwtDecode(token);
      return {
        ...state,
        isAuthenticated: true,
        isAuthenticating: false,
        // A token minted just now carries the user's current roles.
        isSessionChecked: true,
        user: {
          avatar: '/images/avatars/male.png',
          ...decodedToken,
        },
      };
    }

    case SESSION_USER_REFRESHED: {
      // /api/me is the LIVE truth: the JWT roles claim goes stale after an
      // admin grants a role (e.g. ROLE_SUPER_ADMIN) — reconcile so the UI
      // gates on current permissions without forcing a re-login.
      const { roles, username, displayName, disciplines, competitionDisciplines, impersonator, shootingCompetitionIds } = action.data || {};
      if (!roles) {
        return { ...state, isSessionChecked: true };
      }
      return {
        ...state,
        isSessionChecked: true,
        user: {
          ...state.user,
          roles,
          username: username || state.user.username,
          displayName,
          // FSKA / MSAC — where the user works (and so which federations
          // their forms may give), and where they may create a competition.
          // The server's answer, never derived (discipline-access.md, D3/D4).
          disciplines: disciplines || [],
          competitionDisciplines: competitionDisciplines || [],
          // «Увійти як користувач»: the super admin behind this session, or
          // null — the server's word, not localStorage's.
          impersonator: impersonator || null,
          // The competitions whose SHOOTING this user keeps (27 Oct 2026).
          shootingCompetitionIds: shootingCompetitionIds || [],
        },
      };
    }

    case SESSION_USER_REFRESH_FAILED: {
      return { ...state, isSessionChecked: true };
    }

    case LOGIN_REQUEST: {
      return {
        ...noAuthState,
        isAuthenticating: true,
      };
    }

    case LOGIN_FAILURE: {
      return {
        ...noAuthState,
      };
    }

    case LOGOUT_USER: {
      return {
        ...noAuthState,
      };
    }

    default: {
      return state;
    }
  }
};
